import React from 'react';

import StatusPill from '../../shared/status_pill';
import {
  DECISION,
  DECISION_LABEL,
  compare_view,
  large_amount_text,
  row_matches
} from './decisions';

/*
 * one row that needs confirmation: why (its issues), a side-by-side compare with each row or saved
 * entry it resembles (differing fields marked, equal ones greyed), and the Keep / Skip decision
 * with an optional reason. Props-only; the panel owns the decisions.
 */
const FlaggedRow = ({
  view,
  raw,
  rows,
  decision,
  expanded,
  can_decide,
  on_toggle,
  on_decide,
  on_reason
}) => {
  const line = view.line;
  const compares = row_matches(raw).map((m) => compare_view(raw, m, rows));
  const large = large_amount_text(raw);
  const body_id = `tp-flag-${line}`;
  const reason_id = `tp-flag-reason-${line}`;
  return (
    <section className="tp-flag" aria-labelledby={`${body_id}-title`} data-line={line}>
      <div className="tp-flag-hd">
        <span id={`${body_id}-title`} className="tp-flag-title" tabIndex={-1}>
          Row {line} · {view.teacher_name} · {view.amount_text}
        </span>
        <StatusPill tone={decision ? 'green' : 'orange'}>
          {decision ? DECISION_LABEL[decision.action] : 'Needs a decision'}
        </StatusPill>
        <button
          type="button"
          className="tp-link tp-flag-toggle"
          aria-expanded={expanded ? 'true' : 'false'}
          aria-controls={body_id}
          onClick={on_toggle}
        >
          {expanded ? 'Hide comparison' : 'Compare'}
        </button>
      </div>
      <ul className="tp-dup-list">
        {view.issues.map((i, n) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`issue-${n}-${i.code}`} data-code={i.code}>
            {i.text}
          </li>
        ))}
      </ul>
      {expanded ? (
        <div id={body_id} className="tp-flag-body">
          {large ? <p className="tp-flag-large">{large}</p> : null}
          {compares.map((c) => (
            <div key={c.key} className="tp-cmp" data-testid="tp-compare">
              <div className="tp-cmp-row tp-cmp-head" aria-hidden="true">
                <span />
                <span>This row</span>
                <span>{c.title}</span>
              </div>
              {c.fields.map((f) => (
                <div
                  key={f.key}
                  className={`tp-cmp-row ${f.differs ? 'tp-cmp-diff' : 'tp-cmp-same'}`}
                  data-field={f.key}
                >
                  <span className="tp-cmp-k">
                    {f.label}
                    {f.differs ? <span className="tp-cmp-flag"> · differs</span> : null}
                  </span>
                  <span>
                    <span className="tp-cmp-side">This row: </span>
                    {f.mine}
                  </span>
                  <span>
                    <span className="tp-cmp-side">{c.title}: </span>
                    {f.theirs}
                  </span>
                </div>
              ))}
              {c.meta ? <div className="tp-cmp-meta">{c.meta}</div> : null}
            </div>
          ))}
        </div>
      ) : null}
      {can_decide ? (
        <div className="tp-flag-act">
          <div className="tp-actions" role="group" aria-label={`Decision for row ${line}`}>
            {[DECISION.KEEP, DECISION.SKIP].map((a) => (
              <button
                key={a}
                type="button"
                className={`tp-btn-out${decision && decision.action === a ? ' tp-btn-pressed' : ''}`}
                aria-pressed={decision && decision.action === a ? 'true' : 'false'}
                onClick={() => on_decide(line, a)}
              >
                {DECISION_LABEL[a]}
              </button>
            ))}
          </div>
          {decision ? (
            <div className="tp-field tp-flag-reason">
              <label htmlFor={reason_id}>Reason (optional)</label>
              <input
                id={reason_id}
                className="tp-input"
                value={decision.reason || ''}
                maxLength={1024}
                onChange={(e) => on_reason(line, e.target.value)}
              />
            </div>
          ) : null}
        </div>
      ) : null}
    </section>
  );
};

export default FlaggedRow;
